import { render, staticRenderFns } from "./savedItem.vue?vue&type=template&id=5c93b8de&scoped=true&"
import script from "./savedItem.vue?vue&type=script&lang=js&"
export * from "./savedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c93b8de",
  null
  
)

export default component.exports